var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lm-icon-button',{staticClass:"LmReplyButton",attrs:{"icon":"reply","label":"Reply"},on:{"click":function($event){$event.preventDefault();return _vm.onReply.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }